import { DateTime } from "luxon";
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";

import { snackBarEventBus, snackBarEventName } from "@/eventBuses/snackBar.eventBus";

export const upcomingListMixin = Vue.extend({
  data: () => ({
    dialog: false,
    loading: false,
    cancelledId: "",
  }),
  computed: {
    ...mapGetters("encounters", ["encounters"]),
    ...mapGetters(["role"]),
    upcomingItems() {
      return this.encounters
        .filter((e) => ["in-progress", "planned"].includes(e.status))
        .reduce((acc, val) => {
          const currentDate = DateTime.fromISO(val.start).toFormat("ccc, d MMMM yyyy");
          const foundIndex = acc.findIndex((el) => el.date === currentDate);
          if (foundIndex === -1) {
            acc.push({ date: currentDate, items: [val] });
          } else {
            acc[foundIndex].items.push(val);
          }
          return acc;
        }, [])
        .sort((a, b) => new Date(a.date) - new Date(b.date));
    },
  },
  methods: {
    ...mapActions("encounters", ["getAllEncounters"]),
    joinRoom(encounterId) {
      this.$router.push(`/${this.role}/encounters/${encounterId}`);
    },
    onCancel(id) {
      this.dialog = true;
      this.cancelledId = id;
    },
    async getListEncounters() {
      this.loading = true;
      try {
        await this.getAllEncounters({ future: true });
      } catch (e) {
        snackBarEventBus.$emit(snackBarEventName, { message: e.message || e, type: "error" });
      }
      this.loading = false;
    },
  },
  async mounted() {
    await this.getListEncounters();
  },
});
